var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.194,
    height: 32.268,
    viewBox: "0 0 45.194 32.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00404f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Del",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    className: "cls-1",
    d: "M14.134,17.245a2,2,0,0,1-1.467-.64L-1.467,1.36A2,2,0,0,1-1.36-1.467a2,2,0,0,1,2.826.107L14.134,12.3,26.8-1.36a2,2,0,0,1,2.826-.107,2,2,0,0,1,.107,2.826L15.6,16.605A2,2,0,0,1,14.134,17.245Z",
    transform: "translate(15.245) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    className: "cls-1",
    d: "M0,40.851a2,2,0,0,1-2-2V0A2,2,0,0,1,0-2,2,2,0,0,1,2,0V38.851A2,2,0,0,1,0,40.851Z",
    transform: "translate(41.194 14.134) rotate(90)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.38ed2de4e19705585c7add3cc7b37f0f.svg";
export { ForwardRef as ReactComponent };